import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import Dashboard from '../pages/Superadmin/Dashboard'
import { useGlobalContext } from '../context/stateContext'
import Churches from '../pages/Superadmin/Churches'
import RegisterChurch from '../pages/Superadmin/RegisterChurch'
import NotFound from '../pages/NotFound'
import ChurchDetail from '../pages/Superadmin/ChurchDetail'

const SuperadminRoutes = () => {
    
    // useEffect(()=>{
    //     if(user?.role !== "Superadmin"){
    //         document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
    //         window.location.href = '/'
    //     }
    // },[])
  return (
    <Routes>
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path="/churches" element={<Churches />} />
        <Route path="/churches/new/" element={<RegisterChurch />} />
        <Route path="/churches/:id/detail" element={<ChurchDetail />} />
        <Route path="/*" element={<NotFound />} />
    </Routes>
  )
}

export default SuperadminRoutes